import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackageFareDetails } from "redmond";
import { MobilePackagesBookWorkflow } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getRewardsAccounts,
  getSelectedAccount,
} from "../../../rewards/reducer";
import { selectedPackageByRateId } from "../../../hotel-shop/reducer";
import {
  getRecommendedFlights,
  getSelectedReturnFlightPackage,
  selectedFareDetailsSelector,
  getIsTripInternational,
} from "../../../flight-shop/reducer";
import {
  getFlightTripIdentity,
  getSelectedTripIdentity,
} from "../../../flight-shop/utils/useFlightTripIdentity";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
  getPackageAvailabilityInfants,
  getPackageEntryPoint,
  getPackagesAvailabilityDepartureDate,
  getPackagesAvailabilityReturnDate,
} from "../../../availability/reducer";
import { getDestination, getOrigin } from "../../../search/reducer";
import { getFinalizePackageResponse } from "../../../itinerary-review/reducer/selectors";
import {
  getPackageSearchKey,
  getPackagedAirComponent,
  getPackagedAirComponentEntry,
  getPackagedRoomComponent,
  getPackagePollState,
} from "../../../package-identity/reducer/selectors";
import { getPackageHotelIdentity } from "../../../hotel-shop/utils/usePackageHotelIdentity";
import { getPackagePricingIdentity } from "../../../hotel-shop/utils/usePackagePricingIdentity";

export const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTripIdentity(state);
  const { tripDetails } = getFlightTripIdentity(state);
  const hotelIdentity = getPackageHotelIdentity(state);
  const packagePricing = getPackagePricingIdentity(state);
  const fareDetails = selectedFareDetailsSelector(state) as
    | PackageFareDetails
    | undefined;

  const searchedAdultsCount = getPackageAvailabilityAdultsCount(state);
  const searchedChildren = getPackageAvailabilityChildren(state);
  const searchedInfants = getPackageAvailabilityInfants(state);
  const searchedDestination = getDestination(state);
  const searchedOrigin = getOrigin(state);
  const searchedDepartureDate = getPackagesAvailabilityDepartureDate(state);
  const searchedReturnDate = getPackagesAvailabilityReturnDate(state);
  const packageDiscountInfo = fareDetails?.discountInfo;

  return {
    finalizePackageResponse: getFinalizePackageResponse(state),
    selectedTrip,
    // Resolved from v0's own selection, or (under v2) fetched via the GetPackage snapshot's
    // air component — see useFlightTripIdentity. Previously v0-only here, which left this
    // `undefined` under v2 and crashed @capone/checkout's post-payment fulfillment tracking
    // (unguarded `.slices[0]` reads) once that code path became reachable.
    tripDetails,
    selectedLodging: hotelIdentity.selectedLodging,
    selectedRoom: hotelIdentity.selectedRoom,
    selectedRoomRateId: hotelIdentity.selectedRoomRateId,
    hotelFromDate: hotelIdentity.checkIn,
    hotelUntilDate: hotelIdentity.checkOut,
    packagePricing,
    rewardsAccounts: getRewardsAccounts(state),
    searchedAdultsCount,
    searchedChildren,
    searchedInfants,
    searchedDestination,
    searchedOrigin,
    searchedDepartureDate,
    searchedReturnDate,
    recommendedFlights: getRecommendedFlights(state),
    opaqueQuoteRequest: selectedPackageByRateId(state)?.opaqueQuoteRequest,
    opaquePackageToken:
      getSelectedReturnFlightPackage(state)?.opaquePackageToken,
    selectedAccount: getSelectedAccount(state),
    entryPoint: getPackageEntryPoint(state),
    packageDiscountInfo,
    isInternationalTrip: getIsTripInternational(state),
    searchKey: getPackageSearchKey(state),
    packagedRoomComponentV2: getPackagedRoomComponent(state),
    packagedAirComponentV2: getPackagedAirComponent(state),
    packagedAirComponentEntryV2: getPackagedAirComponentEntry(state),
    packagePollState: getPackagePollState(state),
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobilePackagesBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobilePackagesBookWorkflow = withRouter(
  connector(MobilePackagesBookWorkflow)
);
